export default __webpack_public_path__ + "static/unilever-2-logo-svg-vector-51ef6a2c6a40ca98d8fbe5cf701dd935.svg";